/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Job_Detail_Pdf_Export_LabelInputs */

const en_company_job_detail_pdf_export_label = /** @type {(inputs: Company_Job_Detail_Pdf_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF export`)
};

const de_company_job_detail_pdf_export_label = /** @type {(inputs: Company_Job_Detail_Pdf_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Export`)
};

/**
* | output |
* | --- |
* | "PDF export" |
*
* @param {Company_Job_Detail_Pdf_Export_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_job_detail_pdf_export_label = /** @type {((inputs?: Company_Job_Detail_Pdf_Export_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Job_Detail_Pdf_Export_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_job_detail_pdf_export_label(inputs)
	return en_company_job_detail_pdf_export_label(inputs)
});